/** Curated IANA timezones for business settings (Africa-first). */
export const BUSINESS_TIMEZONE_OPTIONS: { value: string; label: string }[] = [
  { value: "Africa/Lagos", label: "Africa/Lagos (WAT)" },
  { value: "Africa/Accra", label: "Africa/Accra (GMT)" },
  { value: "Africa/Johannesburg", label: "Africa/Johannesburg (SAST)" },
  { value: "Africa/Nairobi", label: "Africa/Nairobi (EAT)" },
  { value: "Africa/Cairo", label: "Africa/Cairo (EET)" },
  { value: "Africa/Casablanca", label: "Africa/Casablanca" },
  { value: "Africa/Abidjan", label: "Africa/Abidjan (GMT)" },
  { value: "Africa/Addis_Ababa", label: "Africa/Addis Ababa (EAT)" },
  { value: "Africa/Algiers", label: "Africa/Algiers (CET)" },
  { value: "Africa/Dar_es_Salaam", label: "Africa/Dar es Salaam (EAT)" },
  { value: "Africa/Khartoum", label: "Africa/Khartoum (CAT)" },
  { value: "Africa/Kinshasa", label: "Africa/Kinshasa (WAT)" },
  { value: "Africa/Luanda", label: "Africa/Luanda (WAT)" },
  { value: "Africa/Maputo", label: "Africa/Maputo (CAT)" },
  { value: "Africa/Tunis", label: "Africa/Tunis (CET)" },
  { value: "UTC", label: "UTC" },
  { value: "Europe/London", label: "Europe/London" },
  { value: "America/New_York", label: "America/New York" },
]

export const DEFAULT_BUSINESS_TIMEZONE = "Africa/Lagos"

export const DEFAULT_MAX_AVAILABLE_SLOTS_DAYS = 90
